import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faCalendarAlt, faSmile, faPen } from "@fortawesome/free-solid-svg-icons"; // Импортируем faPen
import { useTranslation } from "react-i18next";

const MyNews = () => {
  const { id } = useParams(); // user_id из URL
  const { t } = useTranslation();
  const [news, setNews] = useState([]);
  const [company, setCompany] = useState(null); // данные компании
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNewsAndCompany = async () => {
      try {
        // Запрос новостей
        const newsResponse = await fetch(`/api/get_company_news.php?user_id=${id}`);
        const newsData = await newsResponse.json();
        if (newsData.success) setNews(newsData.news);

        // Запрос данных компании
        const companyResponse = await fetch(`/api/get_user.php?id=${id}`);
        const companyData = await companyResponse.json();
        if (companyData.success) setCompany(companyData.user); 
      } catch (error) {
        console.error("Ошибка при загрузке новостей или компании:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNewsAndCompany();
  }, [id]);

  return (
    <section className="w-full flex flex-col opacity-0 animate-[showtitle_1s_forwards] py-6 gap-6 px-12 max-sm:px-3">
      {/* Верхняя часть: заголовок и кнопка добавить */}
      <div className="w-full flex justify-between items-center">
        <h1 className="text-white opacity-0 animate-[showtitle_1s_forwards] uppercase text-4xl max-md:text-2xl font-semibold">
          {t("news")}
        </h1>

        <Link
          to={`/AddNews/${id}`}
          className="flex justify-center opacity-0 animate-[showtitle_1s_forwards] items-center py-2 gap-3 px-3 max-sm:p-0 max-sm:w-[40px] max-sm:text-sm max-sm:h-[40px] rounded-full bg-[#00667480] border-2 border-white 
                     text-white text-xl hover:bg-[#006674aa] transition-all duration-300"
          title={t("Add News")}
        >
          <FontAwesomeIcon icon={faPlus} />
          <span className="max-sm:hidden"> {t("post")}</span>
        </Link>
      </div>

      {/* Контент */}
      {loading ? (
        <p className="text-white text-lg animate-pulse">{t("Loading")}...</p>
      ) : news.length === 0 ? (
        <div className="flex flex-col justify-center items-center text-white mt-8">
          <FontAwesomeIcon icon={faSmile} className="text-6xl mb-3 opacity-80" />
          <p className="text-lg">{t("Nonewsyet")}</p>
        </div>
      ) : (
        <section className="w-full mt-12 flex flex-wrap justify-start gap-6">
          {news.map((item) => (
            <article
              key={item.id}
              className="w-[440px] bg-white overflow-hidden rounded-2xl shadow-2xl max-md:w-full flex flex-col justify-between"
            >
              <div>
                <img
                  className="h-[200px] w-full object-cover"
                  src={`/api/uploads/${item.image}`}
                  alt={item.title}
                />
                <ul className="flex flex-col gap-1 p-3 items-start justify-center">
                  {/* Имя компании */}
                  <li>
                    <Link
                      to={`/ViewCompanyPage/${id}`}
                      className="text-xl text-[#006674] font-semibold hover:underline"
                    >
                      {company?.companyName || "Компания"}
                    </Link>
                  </li>
                  {/* Заголовок новости */}
                  <li className="text-2xl max-sm:text-[17px] font-bold uppercase line-clamp-2">
                    {item.title}
                  </li>
                  {/* Описание */}
                  <li className="flex gap-2 justify-start items-center text-gray-600 line-clamp-3">
                    {item.description}
                  </li>
                </ul>
              </div>

              {/* Нижняя панель с кнопками управления */}
              <div className="w-full mt-2 p-2 px-3 flex justify-between items-center bg-[#006674] text-white text-sm sm:text-base">
                {/* Дата публикации */}
                <span>
                  <FontAwesomeIcon className="mr-1" icon={faCalendarAlt} />
                  {new Date(item.created_at).toLocaleDateString()}
                </span>

                {/* Блок управления ссылками (Редактировать и Читать далее) */}
                <div className="flex items-center gap-4">
                  {/* КНОПКА РЕДАКТИРОВАНИЯ */}
                  <Link 
                    to={`/EditNews/${item.id}`} 
                    className="flex items-center gap-1 bg-[#ffffff22] hover:bg-[#ffffff44] transition-all px-2 py-1 rounded-md text-xs sm:text-sm font-medium border border-white/20"
                    title={t("edit") || "Редактировать"}
                  >
                    <FontAwesomeIcon icon={faPen} className="text-xs" />
                    <span>{t("edit") || "Редактировать"}</span>
                  </Link>

                  <Link to={`/News/${item.id}`} className="hover:underline font-semibold">
                    {t("readmore")}
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </section>
      )}
    </section>
  );
};

export default MyNews;